export const engagementAppGroupIdKakaoSenderKeys = "/engagement/:app_group_id/kakao_sender_keys";
